var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReportIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 17.5H15.5M4.5 14H15.5M12.684 0.54C13.1325 0.68 14.5725 1.251 16.6525 3.2795C18.6125 5.191 19.246 6.5485 19.432 7.0645C19.4735 8.185 19.5 9.49 19.5 11C19.5 15.0325 19.3125 17.602 19.1415 19.107C19.0165 20.208 18.19 21.031 17.09 21.1595C15.6825 21.324 13.3835 21.5 10 21.5C6.6165 21.5 4.3175 21.324 2.91 21.16C1.81 21.031 0.9835 20.208 0.8585 19.107C0.6875 17.602 0.5 15.032 0.5 11C0.5 6.968 0.6875 4.398 0.8585 2.893C0.9835 1.792 1.81 0.969 2.91 0.84C4.3175 0.6765 6.6165 0.5 10 0.5C10.985 0.5 11.878 0.515 12.684 0.54Z",
    stroke: "#1B385F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 10.4338C5.786 8.46884 6.8585 7.60584 7.448 7.24384C7.7265 7.07234 8.063 7.18434 8.208 7.47784C8.5395 8.15034 8.853 9.07434 9.0765 9.80784C9.2085 10.2378 9.8365 10.3303 10.113 9.97534C11.226 8.54734 12.75 7.24984 12.75 7.24984M14.7835 8.15984C15.0035 6.99784 15.012 5.97834 14.9935 5.43834C14.9904 5.32471 14.9438 5.2166 14.8635 5.13618C14.7832 5.05575 14.6751 5.00912 14.5615 5.00584C13.6493 4.97822 12.7367 5.04862 11.8395 5.21584C11.4625 5.28734 11.3375 5.74684 11.6095 6.01834L13.9815 8.39084C14.253 8.66234 14.712 8.53684 14.7835 8.15984Z",
    stroke: "#1B385F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/ReportIcon.66b197213432d5740f2275b6f55512b4.svg";
export { ForwardRef as ReactComponent };